module.exports = __webpack_public_path__ + "img/LTU.9df0d678.svg";